module.exports = __webpack_public_path__ + "img/regiter-icon03.a38b6972.png";